/* eslint-disable */

<template>
  <div class="vx-col">
    <vx-card class="mb-base">
      <div class="w-full flex justify-center relative click-item-container">
        <div class="image-container flex items-center" style="position: relative">
          <img
            src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02654257955953151312164/sim-graphic-background.png"
            draggable="false"
            style="width: 100%; height: 100%"
          />

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5.5rem; right: 2.45rem; bottom: 4.5rem"
            @click="componentSelectingIndex = 0"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[0].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[0].score === true ? '#30b851' : components[0].score === false ? '#c93738' : '#acb9c6',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02654257955953151312164/circle-icon.png"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5.5rem; right: 2.45rem; bottom: 13rem"
            @click="componentSelectingIndex = 1"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[1].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[1].score === true ? '#30b851' : components[1].score === false ? '#c93738' : '#acb9c6',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02654257955953151312164/circle-icon.png"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5.5rem; right: 16.9rem; bottom: 4.5rem"
            @click="componentSelectingIndex = 2"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[2].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[2].score === true ? '#30b851' : components[2].score === false ? '#c93738' : '#acb9c6',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02654257955953151312164/circle-icon.png"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5.5rem; right: 16.9rem; bottom: 13rem"
            @click="componentSelectingIndex = 3"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[3].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[3].score === true ? '#30b851' : components[3].score === false ? '#c93738' : '#acb9c6',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02654257955953151312164/circle-icon.png"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5.5rem; left: 2.45rem; bottom: 13rem"
            @click="componentSelectingIndex = 4"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[4].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[4].score === true ? '#30b851' : components[4].score === false ? '#c93738' : '#acb9c6',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02654257955953151312164/circle-icon.png"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>

          <span
            class="absolute flex items-center justify-center cursor-pointer"
            style="width: 5.5rem; height: 5.5rem; left: 2.45rem; bottom: 4.5rem"
            @click="componentSelectingIndex = 5"
          >
            <font-awesome-icon
              :icon="getIconForComponentAnswer(components[5].value)"
              class="h-10 w-10 absolute"
              :style="{
                color: components[5].score === true ? '#30b851' : components[5].score === false ? '#c93738' : '#acb9c6',
                zIndex: 10,
              }"
            />

            <img
              src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/02654257955953151312164/circle-icon.png"
              draggable="false"
              class="w-full h-full absolute"
            />
          </span>
        </div>
      </div>
    </vx-card>

    <movable-popup
      refVal="componentSelectorPopup"
      title="Diagram Components"
      :active="componentSelectingIndex !== -1"
      v-on:close="componentSelectingIndex = -1"
      style="width: fit-content"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <button
            v-for="(icon, index) in icons"
            :key="index"
            class="bg-dark flex items-center text-white font-semibold text-xl gap-4 main-border p-4 w-full h-fit cursor-pointer"
            @click="
              () => {
                components[componentSelectingIndex].value = icon.name;
                components[componentSelectingIndex].score = null;
                componentSelectingIndex = -1;
              }
            "
          >
            <font-awesome-icon
              :icon="icon.icon"
              class="h-8 w-8"
              :style="{ color: components[componentSelectingIndex].value === icon.name ? '#0059ff' : '#acb9c6' }"
            />
            {{ icon.name }}
          </button>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';
import LottieAnimation from '../../../../../../../../components/lottie/LottieAnimation';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      componentSelectingIndex: -1,

      icons: [
        {
          name: 'WAF',
          icon: 'fa-solid fa-fire',
        },
        {
          name: 'RADIUS Server',
          icon: 'fa-solid fa-server',
        },
        {
          name: 'Layer 4 Firewall',
          icon: 'fa-solid fa-block-brick-fire',
        },
        {
          name: 'MFA Proxy',
          icon: 'fa-solid fa-wifi',
        },
        {
          name: 'CASB',
          icon: 'fa-solid fa-cloud',
        },
        {
          name: 'Secure Web Gateway',
          icon: 'fa-solid fa-globe',
        },
      ],

      // Indexed starting at 0 from the top component to the bottom component going left to right
      components: [
        {
          value: '',
          answer: 'CASB',
          score: null,
        },
        {
          value: '',
          answer: 'Layer 4 Firewall',
          score: null,
        },
        {
          value: '',
          answer: 'WAF',
          score: null,
        },
        {
          value: '',
          answer: 'MFA Proxy',
          score: null,
        },
        {
          value: '',
          answer: 'RADIUS Server',
          score: null,
        },
        {
          value: '',
          answer: 'Layer 4 Firewall',
          score: null,
        },
      ],
    };
  },
  methods: {
    getIconForComponentAnswer(answer) {
      const iconObject = this.icons.find((icon) => icon.name === answer);
      return iconObject ? iconObject.icon : 'fa-solid fa-plus';
    },
    markSimulation() {
      let total_score = 0;

      this.components.forEach((field, index) => {
        if (field.value === field.answer) {
          this.components[index].score = true;
          total_score++;
        } else {
          this.components[index].score = false;
        }
      });

      if (total_score === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', total_score);
      }

      this.$emit('simulation_getting_there', total_score);
    },
  },
  components: {
    Prism,
    vSelect,
    MovablePopup,
    LottieAnimation,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
